module.exports = __webpack_public_path__ + "ed931b83fffe271a635ccfbbbb9267d0.svg";


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/forms/rent-app-logo-copy.svg
// module id = 729
// module chunks = 0